"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStoresStatuses = exports.FetchStoresStatusesActions = exports.FetchStoresStatusesActionTypes = exports.ShopifyActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var ShopifyActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_STORES_STATUSES: null
}, 'ecommerce-shopify-v2');
/* Stores status */

exports.ShopifyActionTypes = ShopifyActionTypes;
var FetchStoresStatusesActionTypes = (0, _actions.createRequestTypes)(ShopifyActionTypes.FETCH_STORES_STATUSES);
exports.FetchStoresStatusesActionTypes = FetchStoresStatusesActionTypes;
var FetchStoresStatusesActions = (0, _actions.createRequestActions)(FetchStoresStatusesActionTypes);
exports.FetchStoresStatusesActions = FetchStoresStatusesActions;
var loadStoresStatuses = (0, _fluxActions.createAction)(ShopifyActionTypes.FETCH_STORES_STATUSES);
exports.loadStoresStatuses = loadStoresStatuses;